import { atom } from 'recoil';

// null (not expired) | 'hold' (appointment hold expired) | 'idle' (idle timeout).
export const sessionExpiredState = atom({
  key: 'sessionExpiredState',
  default: null,
});
